import { ImportJobStatusDialogMessage, ImportJobStatusDialogTitle,ImportJobStatusName } from 'common/constants/admin';

import { ApplicationSuite, AppSuiteTenant, ImportType } from '../../../../src/common/types/Entities';

const IMPORT_TEMPLATES_FOLDER = 'import-templates';

export const allRequiredFieldForImportSet = (
    currentImportType: ImportType | null,
    currentAppSuite: ApplicationSuite | null,
    currentTenant: AppSuiteTenant | null,
    currentFileName: string | null,
    currentFile: File | null
) => {
    return !!(
        currentImportType?.name &&
        (!displayAppSuite(currentImportType) || currentAppSuite?.name?.trim()) &&
        (!displayTenant(currentImportType) || currentTenant?.name?.trim() )&&
        currentFileName?.trim() &&
        currentFile
    );
};

export const getTemplateUrl = (templateName: string) => {
    return `${import.meta.env.VITE_URL}/${IMPORT_TEMPLATES_FOLDER}/${templateName}`;
};

export const getTemplatesDetails = () => [
    {
        templateName: 'ACL Entries',
        templateFileName: 'acl-entries-import-template.csv'
    },
    {
        templateName: 'Users',
        templateFileName: 'users-import-template.csv'
    },
    {
        templateName: 'User Group Memberships',
        templateFileName: 'user-group-memberships-import-template.csv'
    },
];

export const ImportNameToTypeMapper: Record<string, string> = {
    'Acl Entries': 'ACLEntries',
    'Users': 'Users',
    'User Group Memberships': 'UserGroupMemberships'
};

export const ImportJobStatusNameToDialogTitle: Record<ImportJobStatusName, ImportJobStatusDialogTitle> = {
    [ImportJobStatusName.UPLOADING]: ImportJobStatusDialogTitle.UPLOADING,
    [ImportJobStatusName.PROCESSING]: ImportJobStatusDialogTitle.PROCESSING,
    [ImportJobStatusName.PARSING_ERRORS]: ImportJobStatusDialogTitle.ERROR,
    [ImportJobStatusName.IMPORT_ERRORS]: ImportJobStatusDialogTitle.ERROR,
    [ImportJobStatusName.SUCCESS]: ImportJobStatusDialogTitle.SUCCESS,
    [ImportJobStatusName.CRITICAL_FAILURE]: ImportJobStatusDialogTitle.CRITICAL_FAILURE
};

export const ImportJobStatusNameToDialogMessage: Record<ImportJobStatusName, ImportJobStatusDialogMessage> = {
    [ImportJobStatusName.UPLOADING]: ImportJobStatusDialogMessage.UPLOADING,
    [ImportJobStatusName.PROCESSING]: ImportJobStatusDialogMessage.PROCESSING,
    [ImportJobStatusName.PARSING_ERRORS]: ImportJobStatusDialogMessage.PARSING_ERRORS,
    [ImportJobStatusName.IMPORT_ERRORS]: ImportJobStatusDialogMessage.IMPORT_ERRORS,
    [ImportJobStatusName.SUCCESS]: ImportJobStatusDialogMessage.SUCCESS,
    [ImportJobStatusName.CRITICAL_FAILURE]: ImportJobStatusDialogMessage.CRITICAL_FAILURE
};

export const importAttemptCompleted = (importStatusName: ImportJobStatusName | undefined): boolean => (
    !(importStatusName == ImportJobStatusName.UPLOADING || importStatusName == ImportJobStatusName.PROCESSING)
);

export const getParsingErrorList = (errorMessage: string) => (
    JSON.parse(errorMessage.slice(errorMessage.indexOf('{'))).errors
);


export const displayAppSuite = (selectedImportType: ImportType | null) => {
    return selectedImportType?.name == 'Acl Entries';
};

export const displayTenant = (selectedImportType: ImportType | null) => {
    return selectedImportType?.name == 'Acl Entries';
};
